import { useState, useEffect, useCallback } from 'react';
import { getBuyerId } from 'dibs-cookie-jar';
import { isEmailOnly } from 'dibs-cookie-jar/exports/isEmailOnly';
import { getEverLoggedIn, cookieJarConstants } from 'dibs-cookie-jar';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';

const {
    LOGIN,
    REGISTER,
    REQUEST_PASSWORD_EMAIL,
    BID_AUCTION_ITEM_FLOW,
} = authModalLoader.constants;
const { USER_EMAIL } = cookieJarConstants;

function getQueryParam(paramName: string): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get(paramName);
}

function getAuthAction({ emailOnly }: { emailOnly: boolean }): string {
    let authAction = '';

    if (emailOnly) {
        authAction = REQUEST_PASSWORD_EMAIL;
    } else {
        const everLoggedIn = !!getEverLoggedIn(document.cookie);
        authAction = everLoggedIn ? LOGIN : REGISTER;
    }
    return authAction;
}

export function useAuctionBidModalState(): {
    isModalOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
} {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = useCallback(async () => {
        const userId = getBuyerId(document.cookie);
        const emailOnly = isEmailOnly(document.cookie);
        if (!!userId && !emailOnly) {
            setIsModalOpen(true);
        } else {
            const authResponse = await authModalLoader.show({
                action: getAuthAction({ emailOnly }),
                email: localStorage.getItem(USER_EMAIL),
                flow: BID_AUCTION_ITEM_FLOW,
                ga: { label: 'bid click - auction PDP' },
            });
            if (authResponse?.userId) {
                setIsModalOpen(true);
            }
        }
    }, []);

    useEffect(() => {
        const modalType = getQueryParam('modal');
        if (modalType === 'bid') {
            openModal();
        }
    }, [openModal]);

    const closeModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);

    return {
        isModalOpen,
        openModal,
        closeModal,
    };
}
